export const MAX_MOBILE_WIDTH = 749
